import {
  CubeFilterKeyValueDimensions,
  DRIFT_CHAT_CONVERSATION_URL_PARAMETERS,
  resultSetToTableData,
} from 'cube'

import { SelectOption } from '@driftt/dds'
import { CubeQuery, CubeQueryBuilder, useCubeQuery } from '@driftt/dds.reports'

type ConversationUrlParametersParamKey = {
  paramKey: string
}

type ConversationUrlParametersParamValue = {
  paramValue: string
}

export const useURLParametersParamKey = () => {
  const query: CubeQuery = new CubeQueryBuilder({
    query: {
      name: 'ConversationUrlParametersParamKey',
      queryName: 'ConversationUrlParametersParamKey',
      query: {
        order: [[DRIFT_CHAT_CONVERSATION_URL_PARAMETERS.COUNT, 'desc']],
      },
    } as CubeQuery,
  })
    .withDimensions([
      CubeFilterKeyValueDimensions.URL_QUERY_PARAMETERS_PARAM_KEY,
    ])
    .build()

  const { data, isLoading, isError } = useCubeQuery({
    query,
  })

  const results = resultSetToTableData(
    data
  ) as ConversationUrlParametersParamKey[]

  const paramOptions = results?.map((e) => {
    return {
      label: `${e.paramKey}`,
      value: `${e.paramKey}`,
    } as SelectOption
  })

  return {
    isLoading,
    isError,
    paramKeys: results || [],
    paramOptions: paramOptions || [],
  }
}

export const useURLParametersParamValuesOfKey = (selectedParamKey: string) => {
  const valuesCubeQuery: CubeQuery = new CubeQueryBuilder({
    query: {
      name: 'ConversationUrlParametersParamValuesOfKey',
      queryName: 'ConversationUrlParametersParamValuesOfKey',
      query: {
        order: [[DRIFT_CHAT_CONVERSATION_URL_PARAMETERS.COUNT, 'desc']],
      },
    } as CubeQuery,
  })
    .withDimensions([
      CubeFilterKeyValueDimensions.URL_QUERY_PARAMETERS_PARAM_VALUE,
    ])
    .withFilters([
      {
        member: CubeFilterKeyValueDimensions.URL_QUERY_PARAMETERS_PARAM_KEY,
        operator: 'equals',
        values: [selectedParamKey],
      },
    ])
    .build()

  const { data, isLoading, isError } = useCubeQuery({
    query: valuesCubeQuery,
  })

  const results = resultSetToTableData(
    data
  ) as ConversationUrlParametersParamValue[]

  const paramValuesOptions = results?.map((e) => {
    return {
      label: `${e?.paramValue}`,
      value: `${e?.paramValue}`,
      key: selectedParamKey,
    } as SelectOption
  })

  return {
    data,
    isLoading,
    isError,
    paramValues: results || [],
    paramValuesOptions: paramValuesOptions || [],
  }
}
